module.exports = __webpack_public_path__ + "img/icon-comments-active.1ddaba9c.svg";